import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaceAutocompleteDirective } from './directives/place-autocomplete.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PlaceAutocompleteDirective],
  exports: [PlaceAutocompleteDirective]
})
export class PlaceAutocompleteModule { }
